<ng-container *ngTemplateOutlet="isCapaciteDisabled ? disabled : enabled"> </ng-container>

<!-- CAPACITÉ DÉSACTIVÉE -->
<ng-template #disabled>
  <dsd-alert class="alert-no-margin-bottom" variant="inactive">
    <h3 slot="title"></h3>
    {{ 'capacite.dashboard-card-status.disabled.texte' | translate }}
  </dsd-alert>
</ng-template>

<ng-template #enabled>
  <ng-container [ngSwitch]="statusCapacite$ | async">
    <ng-container *ngSwitchCase="StatusCapacite.Debute" [ngTemplateOutlet]="debute"></ng-container>
    <ng-container *ngSwitchCase="StatusCapacite.RealisteMaximale" [ngTemplateOutlet]="realisteMaximale"></ng-container>
    <ng-container
      *ngSwitchCase="StatusCapacite.RealisteEgaleMaximale"
      [ngTemplateOutlet]="realisteEgaleMaximale"
    ></ng-container>
    <ng-container *ngSwitchCase="StatusCapacite.Haute" [ngTemplateOutlet]="haute"></ng-container>
    <ng-container *ngSwitchCase="StatusCapacite.Basse" [ngTemplateOutlet]="basse"></ng-container>
    <ng-container *ngSwitchCase="StatusCapacite.Vide" [ngTemplateOutlet]="default"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="default"></ng-container>
  </ng-container>
</ng-template>

<!-- ÉTAT SANS CAPACITE - DÉFAUT -->
<ng-template #default>
  <div data-cy="capacite_default">
    <dsd-tag
      class="dsd-mb-sm"
      [srOnlyIcon]="'capacite.dashboard-card-status.default.temps-sr-icon' | translate"
      icon-name="contenus_contour_temps"
    >
      <span aria-hidden="true">{{ 'capacite.dashboard-card-status.default.temps' | translate }}</span>
    </dsd-tag>
    <p class="dsd-mb-md" [innerHTML]="'capacite.dashboard-card-status.default.texte.' + typeProjet | translate"></p>
    <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="navigatePageAccueil()" data-cy="btn_commencer">
      {{ 'capacite.dashboard-card-status.default.btn-calculer' | translate }}
    </dsd-button>
  </div>
</ng-template>

<!-- ÉTAT DEBUTE -->
<ng-template #debute>
  <div data-cy="capacite_debute">
    <dsd-tag
      class="dsd-mb-sm"
      [srOnlyIcon]="'capacite.dashboard-card-status.default.temps-sr-icon' | translate"
      icon-name="contenus_contour_temps"
    >
      <span aria-hidden="true">{{ 'capacite.dashboard-card-status.default.temps' | translate }}</span>
    </dsd-tag>
    <p class="mb-16" [innerHTML]="'capacite.dashboard-card-status.debute.texte' | translate"></p>
    <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="navigatePageAccueil()" data-cy="btn_calculer">
      {{ 'capacite.dashboard-card-status.debute.btn-continuer' | translate }}
    </dsd-button>
  </div>
</ng-template>

<!-- ÉTAT REALISTE - MAXIMAL -->
<ng-template #realisteMaximale>
  <ng-container class="dsd-mb-lg" data-cy="capacite_realiste_maximale">
    <dsd-grid-row>
      <dsd-grid-col sm-col="6">
        <app-capacity-card
          [title]="
            'capacite.dashboard-card-status.resultats.capacite' + (hasOnlyRealisticCapacity ? '' : '-realiste')
              | translate
          "
          typeCapacite="realiste"
          [valeurPropriete]="valeurProprieteRealiste"
          [versementMensuel]="versementMensuelRealiste"
        ></app-capacity-card>
      </dsd-grid-col>
      <dsd-grid-col sm-col="6">
        <app-capacity-card
          [title]="'capacite.dashboard-card-status.resultats.capacite-maximale' | translate"
          typeCapacite="maximale"
          [valeurPropriete]="valeurProprieteMaximale"
          [versementMensuel]="versementMensuelMaximale"
        ></app-capacity-card>
      </dsd-grid-col>
    </dsd-grid-row>
    <ng-container *ngTemplateOutlet="btnVoirDetails"></ng-container>
  </ng-container>
</ng-template>

<!-- ÉTAT RÉALISTE === MAXIMAL -->
<ng-template #realisteEgaleMaximale>
  <app-capacity-card
    [title]="'capacite.dashboard-card-status.resultats.capacite-maximale' | translate"
    typeCapacite="realiste"
    [valeurPropriete]="valeurProprieteMaximale"
    [versementMensuel]="versementMensuelMaximale"
  ></app-capacity-card>
  <ng-container *ngTemplateOutlet="btnVoirDetails"></ng-container>
</ng-template>

<!-- ÉTAT CAPACITÉ HAUTE -->
<ng-template #haute>
  <app-card class="mb-16" theme="turquoise">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="titre_capacite_haute">
      {{ 'capacite.dashboard-card-status.capacite-haute.titre' | translate }}
    </h3>
    <p>
      {{ 'capacite.dashboard-card-status.capacite-haute.texte' | translate }}
    </p>
    <app-boite-contact [isDSD]="true" buttonStyle="textAndIcon"></app-boite-contact>
  </app-card>
  <ng-container *ngTemplateOutlet="btnVoirDetails"></ng-container>
</ng-template>

<!-- ÉTAT CAPACITÉ BASSE -->
<ng-template #basse>
  <app-card class="mb-16" theme="turquoise">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="titre_capacite_basse">
      {{ 'capacite.dashboard-card-status.capacite-basse.titre' | translate }}
    </h3>
    <p>
      {{ 'capacite.dashboard-card-status.capacite-basse.texte' | translate }}
    </p>
    <app-boite-contact [isDSD]="true" buttonStyle="textAndIcon"></app-boite-contact>
  </app-card>
  <ng-container *ngTemplateOutlet="btnVoirDetails"></ng-container>
</ng-template>

<ng-template #btnVoirDetails>
  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="navigatePageResultat()" data-cy="btn_voir_detail">
    <span aria-hidden="true">{{ 'capacite.dashboard-card-status.btn-voir-details' | translate }}</span>
    <span class="dsd-sr-only">{{ 'capacite.dashboard-card-status.btn-voir-details-sr-only' | translate }}</span>
  </dsd-button>
</ng-template>
